import { render, staticRenderFns } from "./DateInput.vue?vue&type=template&id=b4d1d186&scoped=true"
import script from "./DateInput.vue?vue&type=script&lang=ts"
export * from "./DateInput.vue?vue&type=script&lang=ts"
import style0 from "./DateInput.vue?vue&type=style&index=0&id=b4d1d186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d1d186",
  null
  
)

export default component.exports